import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { asyncValidateEmail } from "../../../services/validation";
import { createRequiredProfileAction } from "../../../redux/actions/profile.actions";
import { renderErrorsList } from "../../../utils/formUtils";
import InputField from "../InputField";

export class RequiredProfileForm extends React.Component {
  handleUpdateProfile = values => {
    this.props.updateProfile(this.props.profile.profile.slug, values);
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="col-lg-2 text-center form-margin-container">
        <h3 id="sign-in-brand">Required Information</h3>
        <br />
        <form onSubmit={handleSubmit(this.handleUpdateProfile)}>
          <Field
            label="First Name"
            hideLabel={true}
            name="first_name"
            type="text"
            id="first-name-input"
            component={InputField}
            placeholder="First Name"
          />
          <Field
            label="Last Name"
            hideLabel={true}
            name="last_name"
            type="text"
            id="last-name-input"
            component={InputField}
            placeholder="Last Name"
          />
          <Field
            label="City"
            hideLabel={true}
            name="city"
            type="text"
            id="city-input"
            component={InputField}
            placeholder="City"
          />
          <Field
            label="Country"
            hideLabel={true}
            name="country"
            type="text"
            id="country-input"
            component={InputField}
            placeholder="Country"
          />
          <Field
            label="Email"
            hideLabel={true}
            name="email"
            type="text"
            id="email-input"
            component={InputField}
            placeholder="Email"
          />
          <br />
          <button type="submit" id="login-btn" className="btn btn-primary">
            Save
          </button>
        </form>

        <br />
        <ul className="list-group">
          {renderErrorsList(this.props.profile.errors)}
        </ul>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  // validate the input data
  if (!values.first_name) {
    errors.first_name = "Enter a first name";
  }

  if (!values.last_name) {
    errors.last_name = "Enter a last name";
  }

  if (!values.city) {
    errors.city = "Enter a city";
  }

  if (!values.country) {
    errors.country = "Enter a country";
  }

  if (!values.email) {
    errors.email = "Enter an email address";
  }
  return errors;
}

const connectedReduxForm = reduxForm({
  validate,
  asyncValidate: asyncValidateEmail,
  asyncChangeFields: ['email'],
  form: "RequiredProfileForm"
})(
  connect(
    ({ profile }) => ({ profile: profile }),
    { updateProfile: createRequiredProfileAction }
  )(RequiredProfileForm)
);

export default connectedReduxForm;



// WEBPACK FOOTER //
// ./src/components/forms/RequiredProfileForm/RequiredProfileForm.jsx